module.exports = __webpack_public_path__ + "static/media/share.2f80e25a.svg";